import React, { useState, useEffect } from "react";
import { fetchUsers } from "services/userService";

const RegistrationConfirmationForm = ({
  tournament,
  user,
  users = [],
  onConfirm,
  onCancel,
}) => {
  const [customName, setCustomName] = useState(user?.name || "");
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const [selectedPartnerName, setSelectedPartnerName] = useState("");
  const [partnerSearch, setPartnerSearch] = useState("");
  const [localUsers, setLocalUsers] = useState(users); // local copy

  useEffect(() => {
    const fetchMissingUsers = async () => {
      if (tournament.type === "Double Open" && users.length === 0) {
        try {
          const fetched = await fetchUsers();
          setLocalUsers(fetched);
        } catch (err) {
          console.error("Erreur lors du chargement des utilisateurs :", err);
        }
      }
    };

    fetchMissingUsers();
  }, [tournament.type, users]);

  const normalize = (str) =>
    str?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const filteredPartners =
    partnerSearch.length >= 3
      ? localUsers.filter((u) => {
          if (u.id === user?.uid) return false; // Exclude self
          const query = normalize(partnerSearch);
          const target = normalize(u.name || u.email || "");
          return target.includes(query);
        })
      : [];

  const handleSubmit = () => {
    const currentUserName = user?.name || "Anonyme";
    const finalTeamName =
      tournament.type === "Double Open" && selectedPartnerName
        ? `${currentUserName} & ${selectedPartnerName}`
        : customName;

    if (!finalTeamName.trim()) {
      alert("Veuillez entrer un nom valide !");
      return;
    }

    if (tournament.type === "Double Open" && !selectedPartnerId) {
      alert("Veuillez sélectionner un partenaire.");
      return;
    }

    const confirmed = window.confirm(
      `Confirmer l'inscription en tant que "${finalTeamName}" ?`
    );
    if (!confirmed) return;

    onConfirm(finalTeamName, selectedPartnerId || null, selectedPartnerName);
  };

  return (
    <div className="space-y-3">
      {tournament.type !== "Double Open" && (
        <input
          type="text"
          value={customName}
          onChange={(e) => setCustomName(e.target.value)}
          placeholder="Votre nom d'inscription"
          className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded text-slate-50"
        />
      )}

      {tournament.type === "Double Open" && (
        <div>
          <input
            type="text"
            value={partnerSearch}
            onChange={(e) => setPartnerSearch(e.target.value)}
            placeholder="Rechercher un partenaire..."
            className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded mb-2 text-slate-50"
          />
          <div className="border border-slate-800 rounded max-h-40 overflow-y-auto">
            {partnerSearch.length < 3 ? (
              <div className="p-2 text-sm text-slate-400 italic">
                Tapez au moins 3 lettres...
              </div>
            ) : filteredPartners.length === 0 ? (
              <div className="p-2 text-sm text-slate-400">Aucun résultat</div>
            ) : (
              filteredPartners.map((u) => (
                <div
                  key={u.id}
                  onClick={() => {
                    setSelectedPartnerId(u.id);
                    setSelectedPartnerName(u.name || u.email);
                    setPartnerSearch(u.name || u.email);
                  }}
                  className={`p-2 cursor-pointer hover:bg-slate-800/50 text-slate-50 ${
                    selectedPartnerId === u.id
                      ? "bg-slate-800/50 font-semibold"
                      : ""
                  }`}
                >
                  {u.name || u.email}
                </div>
              ))
            )}
          </div>
        </div>
      )}

      <div className="flex gap-3">
        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-500"
        >
          Confirmer
        </button>
        <button
          onClick={onCancel}
          className="px-4 py-2 bg-slate-700 text-slate-50 rounded hover:bg-slate-800/50"
        >
          Annuler
        </button>
      </div>
    </div>
  );
};

export default RegistrationConfirmationForm;
